import * as companies from '@/store/Companies/modules/companiesStore'
import * as signIn from '@/store/SignIn/modules/store'
import * as positions from '@/store/PositionList/modules/postionsStore'
import * as departaments from '@/store/PositionList/modules/departmentsStore'
import * as users from '@/store/UserList/modules/userListStore'
import * as bankDetails from '@/store/BankDetails/modules/bankDetailsStore'
import * as serviceCategory from '@/store/ServiceCategory/modules/store'
import * as serviceInstitutions from '@/store/ServiceInstitutions/modules/store'
import * as serviceProject from '@/store/ServiceProject/modules/store'
import * as servicesList from '@/store/ServicesList/modules/store'
import * as invoicesList from '@/store/InvoicesTable/modules/store'
import * as contactsList from '@/store/ContactsList/modules/store'
import * as clientInfo from '@/store/Client/modules/store'
import * as soaList from '@/store/Soa/modules/store'
import * as balanceAccounts from '@/store/BalanceAccounts/modules/store'
import * as balanceClient from '@/store/BalanceClients/modules/store'
import * as balancePartners from '@/store/BalancePartners/modules/store'
import * as payroll from '@/store/Payroll/modules/store'
import * as listOfPayments from '@/store/ListOfPayments/modules/store'
import * as expensesCategory from '@/store/ExpenseCategories/modules/store'
import * as expenses from '@/store/Expenses/modules/store'
import * as cacheRegister from '@/store/CacheRegister/modules/store'
import * as funds from '@/store/Funds/modules/store'
import * as fundsTransfers from '@/store/FundsTransfers/modules/store'
import * as kpi from '@/store/KPI/modules/store'
import * as creditNotes from '@/store/CreditNotes/modules/store'
import * as vatDocs from '@/store/VATDocs/modules/store'
import * as contactsProjects from '@/store/ContactsProjects/modules/store'
import * as contactFinances from '@/store/ContactFinances/modules/store'
import * as writeOff from '@/store/WriteOff/modules/store'
import * as contactDocs from '@/store/ContactDocuments/modules/store'
import * as emailStore from '@/store/Email/modules/store'
import * as logsStore from '@/store/Logs/modules/store'
import * as serviceProviderStore from '@/store/ServiceProvider/modules/store'

export default {
  companiesStore: companies.default.state,
  SignInStore: signIn.default.state,
  positionsStore: positions.default.state,
  departmentsStore: departaments.default.state,
  userListStore: users.default.state,
  bankDetailsStore: bankDetails.default.state,
  ServiceCategoryStore: serviceCategory.default.state,
  ServiceInstitutionsStore: serviceInstitutions.default.state,
  ServiceProjectStore: serviceProject.default.state,
  ServiceListStore: servicesList.default.state,
  invoicesListStore: invoicesList.default.state,
  clientStore: clientInfo.default.state,
  contactsStore: contactsList.default.state,
  SoaStore: soaList.default.state,
  balanceAccountsStore: balanceAccounts.default.state,
  balanceClientsStore: balanceClient.default.state,
  balancePartnersStore: balancePartners.default.state,
  payrollStore: payroll.default.state,
  listOfPaymentsStore: listOfPayments.default.state,
  expenseCategoriesStore: expensesCategory.default.state,
  expensesStore: expenses.default.state,
  cacheStore: cacheRegister.default.state,
  fundsStore: funds.default.state,
  fundsTransfersStore: fundsTransfers.default.state,
  kpiStore: kpi.default.state,
  creditNotesStore: creditNotes.default.state,
  vatDocs: vatDocs.default.state,
  contactsProjects: contactsProjects.default.state,
  contactFinances: contactFinances.default.state,
  writeOff: writeOff.default.state,
  contactDocs: contactDocs.default.state,
  emailStore: emailStore.default.state,
  logsStore: logsStore.default.state,
  serviceProviderStore: serviceProviderStore.default.state
}



// WEBPACK FOOTER //
// ./src/store/ResetStore/index.js